<template>
  <div class="pie-chart" :style="{ width: '100%', height: '100%', position: 'relative' }">
    <NoData v-show="isNoData"></NoData>
    <div ref="container" :style="{ width: '100%', height: '100%' }"></div>
    <ChartLegendSwtich
      :legend-default-status="isShowLegendDefault"
      @switchStatus="handleShowOrHiddenLegend"
    ></ChartLegendSwtich>
    <div class="date-selector">
      <!-- <el-select
        v-model="selectedValue"
        v-show="this.pieData.length !== 0"
        @change="handleSelect"
        :popper-append-to-body="false"
        placeholder="请选择"
      >
        <el-option v-for="(item, index) in categories" :key="index" :label="item" :value="index">
        </el-option>
      </el-select> -->
      <!-- <select name="select" onchange="handleSelect(this.value)">
        <option v-for="(item, index) in categories" :key="index" :value="index">{{ item }}</option>
      </select> -->
      <Selector
        :options="categories"
        :selected-value="selectedValue"
        @handleSelect="handleSelect"
      ></Selector>
    </div>
  </div>
</template>

<script>
import { resizeChart, getChartBase64 } from "@/utils/chartMethods"
import * as echarts from "echarts"
import getOption from "./option"
import NoData from "@/components/NoData"
import Selector from "../../Selector"
import ChartLegendSwtich from "@/components/ChartLegendSwtich"
export default {
  props: {
    // scale: {
    //   type: Object,
    //   require: true,
    // },
    pieRoseType: {
      type: String,
      default: "",
    },
    pieLabelLine: {
      type: Boolean,
      default: false,
    },
    pieTitle: {
      type: String,
      require: true,
    },
    pieRadius: {
      type: Array,
      require: false,
    },
    pieData: {
      type: Array,
      default: () => [],
    },
    isShowLegendDefault: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NoData,
    Selector,
    ChartLegendSwtich,
  },
  watch: {
    pieData: {
      handler(newPie) {
        if (!this.option) return
        this.processdData.length = 0
        //处理折线图数据
        this.categories = new Set()
        let names = []
        newPie.forEach((pie) => {
          const { name, data } = pie
          for (let key in data) {
            this.categories.add(key)
          }
          names.push(name)
        })
        this.categories = Array.from(this.categories).sort()
        names = Array.from(names).sort()

        this.option.legend.data = names

        newPie.forEach((pie) => {
          const { name, data } = pie
          this.categories.forEach((category, index) => {
            const newData = { name }
            if (!this.processdData[index]) this.processdData.push([])
            if (data && data[category]) newData.value = data[category]
            else newData.value = 0
            this.processdData[index].push(newData)
          })
        })
        this.option.series[0].data = this.processdData[0]
        this.pie.setOption(this.option, true)
        this.selectedValue = 0
      },
      //立即监听（初始化）
      immediate: true,
      //深度监听
      deep: true,
    },
  },

  data() {
    return {
      pie: null,
      option: null, //配置项
      processdData: [],
      categories: [],
      selectedValue: 0,
      isShowLegend: this.isShowLegendDefault,
    }
  },
  computed: {
    isNoData: function () {
      return this.pieData.length === 0
        ? true
        : Object.keys(this.pieData[0].data).length === 0 &&
            Object.keys(this.pieData[1].data).length === 0
    },
  },
  mounted() {
    //初始化pie
    this.init()
  },
  methods: {
    init() {
      this.pie = echarts.init(this.$refs["container"])
      //获取option对象，防止同种类各图相互影响
      this.option = getOption()
      if (this.pieTitle) this.option.title.text = this.pieTitle
      if (this.pieRadius) {
        this.option.series[0].radius = this.pieRadius
      }
      if (this.pieRoseType) {
        this.option.series[0].roseType = this.pieRoseType
      }
      if (this.pieLabelLine) {
        this.option.series[0].label.show = true
        this.option.series[0].label.position = "outside"
        this.option.series[0].label.formatter = "{b}:{c}" + "\n\r" + "({d}%)"
      }

      this.categories = new Set()
      let names = []
      this.pieData.forEach((pie) => {
        const { name, data } = pie
        for (let key in data) {
          this.categories.add(key)
        }
        names.push(name)
      })
      this.categories = Array.from(this.categories).sort()
      names = Array.from(names).sort()

      //控制是否显示图例
      this.option.legend.show = this.isShowLegend
      if (this.isShowLegendDefault) this.option.legend.textStyle.fontSize = "12px"
      this.option.legend.data = names

      /*********************************************************** */
      /**
       *
       * 没有效果，刚加载时pieData没有值
       */
      this.pieData.forEach((pie) => {
        const { name, data } = pie
        this.categories.forEach((category, index) => {
          const newData = { name }
          if (!this.processdData[index]) this.processdData.push([])
          if (data && data[category]) newData.value = data[category]
          else newData.value = 0
          this.processdData[index].push(newData)
        })
      })
      /*********************************************************** */
      this.option.series[0].data = this.processdData[0]
      this.pie.setOption(this.option)
      //图表自适应
      resizeChart(this.pie)
    },
    handleSelect(index) {
      this.selectedValue = index
      console.log(this.option.series[0].data, this.processdData)
      this.option.series[0].data = this.processdData[this.selectedValue]

      this.pie.setOption(this.option)
    },
    handleShowOrHiddenLegend(flag) {
      this.isShowLegend = flag
      //控制是否显示图例
      this.option.legend.show = this.isShowLegend
      this.pie.setOption(this.option)
    },
    handleSaveImage() {
      return getChartBase64(this.pie)
    },
  },
}
</script>

<style lang="scss" scoped>
.pie-chart {
  position: relative;
  .date-selector {
    width: 20%;
    position: absolute;
    right: 5%;
    top: 5%;
  }
}
</style>
